"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkUtil = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
class LinkUtil {
    static computeProjectPointAndFactor(mainPipe, point, coordinateUtil) {
        //拷贝一份，避免改变原来的线段
        let mainPipe_local = coordinateUtil.transformLineSegmentToLocal(mainPipe);
        let angle = mainPipe_local.angle(); //范围为-PI~PI
        angle = Math.abs(angle * 180 / Math.PI);
        if (angle < 0.1 || Math.abs(angle - 90) < 0.1 || angle > 179.9) { //房间角度与主管线为直角
            var projectionFactor = mainPipe.projectionFactor(point);
            var projectionPoint = mainPipe.pointAlong(projectionFactor);
        }
        else {
            let point_local = coordinateUtil.transformPointToLocal(point);
            let xDirectionSegment = new LineSegment_js_1.default(point_local, new Coordinate_js_1.default(point_local.x + 1, point_local.y));
            let yDirectionSegment = new LineSegment_js_1.default(point_local, new Coordinate_js_1.default(point_local.x, point_local.y + 1));
            let xDirectionIntersectP = mainPipe_local.lineIntersection(xDirectionSegment);
            let yDirectionIntersectP = mainPipe_local.lineIntersection(yDirectionSegment);
            //判断哪个交点更近
            if (point_local.distance(xDirectionIntersectP) < point_local.distance(yDirectionIntersectP)) {
                var projectionPoint = coordinateUtil.transformPointToWorld(xDirectionIntersectP);
            }
            else {
                var projectionPoint = coordinateUtil.transformPointToWorld(yDirectionIntersectP);
            }
            var projectionFactor = this.computeFactor(mainPipe, projectionPoint);
        }
        return {
            projectionFactor: projectionFactor,
            projectionPoint: projectionPoint
        };
    }
    static computeFactor(mainPipe, point) {
        const dx = mainPipe.p1.x - mainPipe.p0.x;
        const dy = mainPipe.p1.y - mainPipe.p0.y;
        const len = dx * dx + dy * dy;
        return ((point.x - mainPipe.p0.x) * dx + (point.y - mainPipe.p0.y) * dy) / len;
    }
    static linkSegmentOverlapWithPipe(node, child, coordinateUtil) {
        let linkSeg = new LineSegment_js_1.default(node._point, child._point);
        let childPoints = [];
        for (let c of node._children) {
            childPoints.push(coordinateUtil.transformPointToLocal(c._point));
        }
        for (let c of child._children) {
            childPoints.push(coordinateUtil.transformPointToLocal(c._point));
        }
        for (let point of childPoints) {
            if (linkSeg.distance(point) < 1)
                return true;
        }
        return false;
    }
}
exports.LinkUtil = LinkUtil;
